import Layout from '@/layout/Layout.vue';
import { P } from '@/config/permissions';

// Luce — assistant interne (proxy LiteLLM), Lot 1.
// L'entrée de menu n'apparaît que pour les rôles portant `use ai chat` ;
// le backend refait le contrôle sur chaque route de l'API.
const aiRoutes = {
  path: '/luce',
  component: Layout,
  name: 'Luce',
  meta: {
    title: 'Luce',
    permissions: [P.AI.CHAT],
  },
  children: [
    {
      path: '',
      component: () => import('@/views/ai/AiChat.vue'),
      name: 'LuceChat',
      meta: {
        title: 'Luce',
        icon: 'prosoluce:luce',
        permissions: [P.AI.CHAT],
        noCache: true,
      },
    },
  ],
};

export default aiRoutes;
